






















































import { Component, Vue } from 'vue-property-decorator';
import ToolBox from '@/components/common/ToolBox.vue';
import { Product } from '@/api/com/MetaPattern/MDA/MD/Base/Product';
import { MDExtendService } from '@/libs/com/MetaPattern/MDA/MD/MDExtendService';
import { EnumComponentType, EnumComponentTypeMD } from '@/api/com/MetaPattern/MDA/MD/Base/EnumComponentType';
import { BaseElement } from '@/api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { Tree } from 'element-ui';
import { BaseComponent } from '@/api/com/MetaPattern/MDA/MD/Base/BaseComponent';
import { EventBus } from '@/libs/com/MetaPattern/Product/IDE/Util/EventBus';
import { EnumPersistenceStatus } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { ProductComponent } from '@/api/com/MetaPattern/MDA/MD/ProductModel/ProductComponent';
import { ProductComponentService } from '@/api/com/MetaPattern/MDA/MD/ProductModel/ProductComponentService';
import { MDRepository } from '@/libs/com/MetaPattern/MDA/MD/MDRepository';
import { ProductTree } from '@/libs/com/MetaPattern/MDA/MD/ProductTree';
import { BaseService } from '@/api/com/MetaPattern/MDA/MD/Base/BaseService';
import { ValidateHelper } from '@/libs/com/MetaPattern/Product/IDE/Util/ValidateHelper';
import { WorkScope } from '@/api/com/MetaPattern/MDA/MD/Base/WorkScope';
import { ProductService } from '@/api/com/MetaPattern/MDA/MD/Base/ProductService';
import { ValidationResult } from '@/api/com/MetaPattern/Core/Infrastructure/Common/ValidationResult';
import { MDValidation } from '@/libs/com/MetaPattern/MDA/MD/MDValidation';
import { MDAConstant } from '@/libs/com/MetaPattern/MDA/Designer/Base/MDAConstant';
import { DesignerExtendService } from '@/libs/com/MetaPattern/MDA/Designer/DesignerExtendService';
import AddProduct from '@/components/MDA/MD/AddProduct.vue';
import { APP } from '@/api/com/MetaPattern/MDA/MD/Base/APP';

@Component({
  components: {
    AddProduct,
    ToolBox
  }
})
export default class ProductScope extends Vue {
  private showAddProduct = false;
  private newProduct: Product;
  private newProductKey = 0;
  private sysAPP: APP; // 系统应用
  private _hasProduct: boolean;
  private tree: Array<ProductTree>;
  private key = 0;
  expandedList: string[] = [];
  private loading = true;

  constructor() {
    super();
    this.showAddProduct = false;
    this.newProduct = null;
    this.sysAPP = null;
    this._hasProduct = false;
    this.loading = true;
  }

  get products(): Array<Product> {
    if (this.$store.state.ModuleMD.productCount === 0) {
      MDExtendService.GetProductTreeAsync().then((response) => {
        response.forEach(product => {
          if (ValidateHelper.IsNotNullOrEmpty(product.workScope_ID)) {
            product.workScope = this.$store.state.ModuleMD.workScopes.find((item: WorkScope) => item.id === product.workScope_ID);
          }
        });
        this.loading = false;
        this.$store.dispatch('ModuleMD/setProductsAction', response as Array<Product>);
      });
    } else {
      this.loading = false;
    }
    return this.$store.state.ModuleMD.products;
  }

  set products(value: Array<Product>) {
    this.$store.dispatch('ModuleMD/setProductsAction', value);
  }

  get productData() {
    this.tree = new Array<ProductTree>();
    this.products.forEach((product) => this.tree.push(new ProductTree(product)));
    return this.tree;
  }

  get refreshKey() {
    return this.key;
  }

  get defaultProps() {
    return {
      label: 'displayName',
      children: 'components',
      designId: 'designId',
      status: 'status'
    };
  }

  getComponentTypeName(componentType: EnumComponentType) {
    if (componentType) {
      return '[' + EnumComponentTypeMD.getItemByValue(componentType).name.substring(0, 3) + ']';
    }
    return '';
  }

  getHasProduct(): boolean {
    return this.$store.state.ModuleMD.productCount > 0;
  }

  getProductCount(): number {
    return this.$store.state.ModuleMD.productCount;
  }

  deletable(data: BaseComponent | ProductTree) {
    if (data instanceof ProductComponent) {
      return false;
    }
    return true;
  }

  /** 打开节点设置 */
  nodeSetting(data: BaseElement | ProductTree, evt: any) {
    // 如果是产品，则打开产品设置
    const curProduct = this.$store.state.ModuleMD.products.find((product: Product) => product.designId === data.designId) as Product;
    if (curProduct) {
      // EventBus.$emit('openPage', 'views/pages/Setting.vue', `${curProduct.name}Setting`, `${curProduct.displayName}设置`, { productId: curProduct.id });
      EventBus.$emit('openPage', 'views/pages/ProductPipeline.vue', `${curProduct.name}Pipeline`, `${curProduct.displayName}流水线`, { product: curProduct, productId: curProduct.id });
    }
    evt.stopPropagation();
  }

  handleNodeClick(data: BaseElement): void {
    this.$store.dispatch('ModuleMD/setCurMDDesignIdAction', data.designId);
  }

  /* 更新前设置扩展的节点，重新渲染即可选中。如果在点击事件中操作，则导致每次点击都会出发重新渲染树 */
  beforeUpdate(): void {
    this.expandedList = [];
    this.expandedList.push(this.$store.state.ModuleMD.curMDDesignId);
  }

  /* 数据更新后，设置当前高亮的节点 */
  updated(): void {
    (this.$refs.tree as Tree).setCurrentKey(this.$store.state.ModuleMD.curMDDesignId);
  }

  openDoc(data: BaseComponent) {
    this.handleNodeClick(data);
    EventBus.$emit('openDoc', data);
  }

  /** 保存组件或产品 */
  save(data: BaseComponent | ProductTree) {
    const errors = new Array<ValidationResult>();
    console.log(data);
    if (data instanceof ProductTree) {
      MDValidation.validateProduct(data.product, errors);
      data.product.productComponents.forEach(com => {
        if (com.persistenceStatus !== EnumPersistenceStatus.None) {
          MDValidation.validateProductComponent(com, errors);
        }
      });
    } else if (data instanceof ProductComponent) {
      MDValidation.validateProductComponent(data, errors);
    }
    if (errors.length > 0) {
      this.$store.dispatch('ModuleMD/setValidationErrorsAction', errors);
      this.$message({ type: 'error', message: '校验失败，不能保存，请查看错误列表，修复后再保存!' });
      return;
    }
    if (data instanceof ProductTree) {
      const product = new Product();
      product.copyFrom(data.product, false);
      BaseService.SaveProductAsync(product)
        .then((response) => {
          if (response) {
            const element = this.$store.state.ModuleMD.elements.find((item: BaseElement) => item.designId === product.designId) as Product;
            if (element) {
              element.persistenceStatus = EnumPersistenceStatus.None;
              this.$store.dispatch('ModuleMD/setOutputMessagesAction', `产品 [${product.displayName}] 保存成功。`);
              element.productComponents.forEach(com => {
                if (com.persistenceStatus !== EnumPersistenceStatus.None) {
                  this.saveComponentAsync(com);
                }
              });
            }
          }
        });
    } else if (data instanceof BaseComponent) {
      this.saveComponentAsync(data);
    }
  }

  async saveComponentAsync(data: BaseComponent): Promise<BaseComponent> {
    return new Promise((resolve, reject) => {
      let component: BaseComponent = null;
      if (data instanceof ProductComponent) {
        component = new ProductComponent();
      }
      if (component !== null) {
        component.copyFrom(data, false);
        const deleteDesignIds = new Array<string>();
        MDExtendService.SaveComponentAsync(component, deleteDesignIds)
          .then((response) => {
            if (response) {
              const element = this.$store.state.ModuleMD.elements.find((item: BaseElement) => item.designId === component.designId) as BaseComponent;
              if (element) {
                element.persistenceStatus = EnumPersistenceStatus.None;
                this.$store.dispatch('ModuleMD/setOutputMessagesAction', `组件 [${component.displayName}] 保存成功。`);
                resolve(element);
              }
            }
          })
          .catch((error) => {
            reject(error);
          });
      }
      resolve(null);
    });
  }

  /** 删除组件或产品 */
  deleteNode(data: BaseComponent | ProductTree) {
    let message = '';
    if (data instanceof BaseComponent) {
      message = `此操作将永久删除组件 [${data.displayName}]，不可恢复，是否继续?`;
    } else if (data instanceof ProductTree) {
      message = `此操作将永久删除产品 [${data.displayName}] 以及其下属的组件，不可恢复，是否继续?`;
    }
    this.$confirm(message, '删除提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      console.log(data);
      if (data instanceof ProductTree) {
        this.deleteProduct(data);
      } else if (data instanceof BaseComponent) {
        this.deleteComponent(data);
      }
    }).catch(() => {
      // 取消删除
    });
  }

  /** 删除应用及下面的所有组件，并保存 */
  deleteProduct(data: ProductTree) {
    const findProduct = this.products.find(product => data.id === product.id);
    if (findProduct) {
      if (findProduct.persistenceStatus === EnumPersistenceStatus.Create) {
        this.deleteProductDone(findProduct);
      } else {
        const promiseAll = [] as unknown[];
        promiseAll.push(ProductService.DeleteAsync(findProduct.id));
        const productComponentDesignIds = [] as string[];
        findProduct.productComponents.forEach(com => {
          productComponentDesignIds.push(com.id);
        });
        if (productComponentDesignIds.length > 0) {
          promiseAll.push(ProductComponentService.DeleteBatchAsync(productComponentDesignIds));
        }
        Promise.all(promiseAll)
          .then((result: unknown[]) => {
            const productSuccess = result[0] as boolean;
            if (productSuccess) {
              this.deleteProductDone(findProduct);
            }
          })
          .catch((error: any) => {
            this.$message({ type: 'error', message: '删除产品失败!原因是：' + error });
            this.$store.dispatch('ModuleMD/setOutputMessagesAction', `产品 [${findProduct.displayName}] 删除失败！原因是：${error}`);
          });
      }
    }
  }

  /** 删除产品成功以后 */
  deleteProductDone(findProduct: Product) {
    const products = this.$store.state.ModuleMD.products as Array<Product>;
    let findIndex = products.findIndex((product: Product) => product.designId === findProduct.designId);
    if (findIndex > -1) {
      products.splice(findIndex, 1);
    }
    const elements = this.$store.state.ModuleMD.elements as Array<BaseElement>;
    findIndex = elements.findIndex((element: BaseElement) => element.designId === findProduct.designId);
    if (findIndex > -1) {
      elements.splice(findIndex, 1);
    }
    findProduct.productComponents.forEach(component => {
      findIndex = elements.findIndex((element: BaseElement) => element.designId === component.designId);
      if (findIndex > -1) {
        elements.splice(findIndex, 1);
      }
    });
    this.$message({ type: 'success', message: '删除产品成功!' });
    this.$store.dispatch('ModuleMD/setOutputMessagesAction', `产品 [${findProduct.displayName}] 及下属所有组件 删除成功`);
  }

  /** 删除组件 */
  deleteComponent(component: BaseComponent) {
    const findProduct = this.products.find(product => component.aPP_ID === product.id);
    if (findProduct) {
      // 具体的组件删除操作，以后增加组件的时候填充
    }
  }

  hasModified(data: any) {
    let persistenceStatus: EnumPersistenceStatus;
    if (data instanceof ProductTree) {
      persistenceStatus = data.product.persistenceStatus;
    } else if (data instanceof BaseElement) {
      persistenceStatus = data.persistenceStatus;
    }
    return persistenceStatus !== EnumPersistenceStatus.None;
  }

  /**
   * 下拉菜单命令处理
   * @param action 命令：命令名称、数据
   */
  menuCommand(action: any) {
    if (action.command) {
      if (action.command === 'createProduct') {
        const product = this.products.find((item) => item.designId === action.data);
        if (product !== null) {
          if (product.productComponents.length < 1) {
            let componentType = EnumComponentType.Product;
            if (action.command === 'createProduct') {
              componentType = EnumComponentType.Product;
            }
            MDRepository.createProductComponent(product, this.getSysAPP(), componentType).then((component) => {
              if (component !== null) {
                this.key++;
                if (product.persistenceStatus !== EnumPersistenceStatus.Create) {
                  product.persistenceStatus = EnumPersistenceStatus.Update;
                }
                this.$store.dispatch('ModuleMD/setElementAction', { element: component, componentDesignId: component.designId });
              }
            });
          } else {
            this.$message({ type: 'error', message: '每个产品有且只能有一个产品组件!' });
          }
        }
      } else if (action.command === 'deleteNode') {
        this.deleteNode(action.data);
      }
    }
  }

  /**
   * 获取系统应用
   */
  getSysAPP(): APP {
    // 确保系统应用存在才能创建产品
    if (this.sysAPP === null) {
      const apps = this.$store.state.ModuleMD.apps as Array<APP>;
      for (const app of apps) {
        if (app.isSystem) {
          this.sysAPP = app;
          break;
        }
      }
    }
    return this.sysAPP;
  }

  /** 添加一个新的产品，并创建Product组件 */
  addProduct(): void {
    // 理论上不应该不存在系统应用
    this.newProductKey++;
    this.newProduct = null;
    this.showAddProduct = true;
  }

  closeEdit(entity: Product) {
    this.showAddProduct = false;
    if (entity !== null) {
      MDRepository.createProductAsync(entity.name, entity.displayName, entity.description, entity.rootNamespace, entity.workScope_ID, this.getSysAPP())
        .then((product) => {
          product.workScope = entity.workScope;
          const items = this.$store.state.ModuleMD.products as Array<Product>;
          items.push(product);
          this.$store.dispatch('ModuleMD/setProductsAction', items);
          BaseService.SaveProductAsync(product)
            .then((response) => {
              if (response) {
                const element = this.$store.state.ModuleMD.elements.find((item: BaseElement) => item.designId === product.designId) as Product;
                if (element) {
                  element.persistenceStatus = EnumPersistenceStatus.None;
                  this.$store.dispatch('ModuleMD/setOutputMessagesAction', `产品 [${product.displayName}] 保存成功。`);
                  if (element.productComponents.length > 0) {
                    const component = element.productComponents[0];
                    component.persistenceStatus = EnumPersistenceStatus.None;
                    component.productAPPs.forEach((productAPP) => {
                      productAPP.persistenceStatus = EnumPersistenceStatus.None;
                    });
                    this.$store.dispatch('ModuleMD/setCurMDDesignIdAction', component.designId);
                    EventBus.$emit('openDoc', component);
                  }
                }
              }
            });
        });
    }
  }

  hasProductComponent(product: Product): boolean {
    return product.productComponents.length === 1;
  }

  getTypeIcon(data: any) {
    let typeName = '';
    const element = data;
    if (element) {
      if (element instanceof Product) {
        typeName = MDAConstant.Type.ADD_PRODUCT;
      } else if (element instanceof ProductComponent) {
        typeName = MDAConstant.Type.ADD_PRODUCTCOMPONENT;
      }
    }
    if (typeName !== '') {
      return DesignerExtendService.getTypeIcon(typeName);
    }
    return '';
  }
}
